import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type { Inquiry, Request } from '@app/src/types/resourceExplorer'

const useProviderInquiries = (request?: Request) =>
  useFetchCollectionWithPost<Inquiry>({
    key: FetchKey.InquiryOpenRequests,
    endpoint: endpoints.inquiriesCollection,
    payload: {
      filter: [
        {
          name: 'questionnaireTemplateId',
          filters: [
            {
              operator: Operators.EqualTo,
              value: request?.questionnaireTemplateId,
            },
          ],
        },
        {
          name: 'periodName',
          filters: [
            {
              operator: Operators.EqualTo,
              value: request?.periodName,
            },
          ],
        },
        ...(request?.targetProductId
          ? [
              {
                name: 'targetProductId',
                filters: [
                  {
                    operator: Operators.EqualTo,
                    value: request.targetProductId,
                  },
                ],
              },
            ]
          : [
              {
                name: 'targetProductId',
                filters: [
                  {
                    operator: Operators.IsNull,
                  },
                ],
              },
            ]),
      ],
      include: ['creatorOrganization.image'],
    },
    options: { enabled: Boolean(request) },
  })

export default useProviderInquiries
